// Force CJS build to avoid webpack 5 scope hoisting collision between
// fflate's strToU8 and groundcover's internal class — both get renamed to `e`
// causing groundcover.initialize() to call strToU8.initialize() instead.
// eslint-disable-next-line @typescript-eslint/no-require-imports
const groundcover = require('@groundcover/browser') as typeof import('@groundcover/browser').default;
export default groundcover;
